import { RadioGroupOptionItem } from 'components/Popover';
import { Option } from 'components/RadioOptions';
import {
  GenerateSocialPostCaptionsFormality,
  GenerateSocialPostCaptionsTone,
} from 'redux/middleware/api/video-export-service/types';

export const FORMALITY_OPTIONS: Option<
  GenerateSocialPostCaptionsFormality
>[] = [
  {
    label: 'Neutral',
    value: 'neutral',
  },
  {
    label: 'Casual',
    value: 'casual',
  },
  {
    label: 'Formal',
    value: 'formal',
  },
];

export const TONE_OPTIONS: Option<GenerateSocialPostCaptionsTone>[] = [
  {
    label: 'Direct',
    value: 'direct',
  },
  {
    label: 'Empathetic',
    value: 'empathetic',
  },
  {
    label: 'Witty',
    value: 'witty',
  },
];

export const REGENERATE_TEXT_OPTIONS: RadioGroupOptionItem<
  GenerateSocialPostCaptionsFormality | GenerateSocialPostCaptionsTone
>[] = [
  {
    id: 'formality',
    label: 'formality',
    options: FORMALITY_OPTIONS,
  },
  {
    id: 'tone',
    label: 'tone',
    options: TONE_OPTIONS,
  },
];
